module.exports = "/shared/img/ticket-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/ticket-background.png
// module id = 429
// module chunks = 11